<template>
  <div class="card">
    <div class="card-top">
      <div>
        <span class="card-top-type">企业</span>
        <span style="font-weight: 500">{{ data.fromCompanyName }}</span>
      </div>
      <div style="color: #2948ff">
        {{ data.accountType == "PERSON" ? "个人" : "企业" }}
      </div>
    </div>
    <ve-table
      :columns="columns"
      :table-data="tableData"
      :cell-style-option="cellStyleOption"
    />
    <div class="card-bottom" v-if="data.accountType !== 'PERSON'">
      <span>账户</span>
      <span>{{ data.accountCompanyName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "currency"],
  computed: {
    tableData() {
      return [this.data];
    },
  },
  watch: {
    currency: {
      handler(newval, old) {
        if (newval === "GOLD") {
          this.$set(this.columns, 0, { ...this.columns[0], title: "账户金料" });
          this.$set(this.columns, 1, { ...this.columns[1], title: "冻结金料" });
          this.$set(this.columns, 2, { ...this.columns[2], title: "可用金料" });
        } else {
          this.$set(this.columns, 0, { ...this.columns[0], title: "账户余额" });
          this.$set(this.columns, 1, { ...this.columns[1], title: "冻结余额" });
          this.$set(this.columns, 2, { ...this.columns[2], title: "可用余额" });
        }
      },
    },
  },
  data() {
    return {
      columns: [
        {
          field: "balance",
          key: "a",
          title: "账户金料",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.currency === "GOLD"
                  ? row.balance.toFixed(2) + "g"
                  : row.balance.toFixed(2) + "元"}
              </span>
            );
          },
        },
        {
          field: "freezeAmount",
          key: "b",
          title: "冻结金料",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.currency === "GOLD"
                  ? row.freezeAmount.toFixed(2) + "g"
                  : row.freezeAmount.toFixed(2) + "元"}
              </span>
            );
          },
        },
        {
          field: "availableAmount",
          key: "c",
          title: "可用金料",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.currency === "GOLD"
                  ? row.availableAmount.toFixed(2) + "g"
                  : row.availableAmount.toFixed(2) + "元"}
              </span>
            );
          },
        },
      ],
      // tableData: [],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          return "header-cell";
        },
        bodyCellClass: ({ row, col }) => {
          return "body-cell";
        },
      },
    };
  },

  created() {},

  methods: {},
};
</script>

<style lang="less" scoped>
::v-deep .header-cell {
  background: #f7f9ff !important;
  color: #333333 !important;
  height: 64px;
  font-size: 26px !important;
}
::v-deep .body-cell {
  height: 64px !important;
  color: #000000 !important;
  font-size: 26px !important;
}
.card {
  border-radius: 24px;
  width: 100%;
  min-height: 100px;
  background-color: #ffffff;
  padding: 32px;
  &-bottom {
    margin-top: 16px;
    display: flex;
    gap: 16px;
    font-size: 26px;
    > span:nth-child(1) {
      color: #999999;
    }
  }
  &-top {
    margin-bottom: 24px;
    font-size: 28px;
    display: flex;
    justify-content: space-between;
    &-type {
      color: #999999;
      margin-right: 24px;
    }
  }
}
</style>
